__turbopack_context__.v({
  "sponsorLogo": "sponsorLogoRow-module-scss-module__w5v9IG__sponsorLogo",
  "sponsorLogoRow": "sponsorLogoRow-module-scss-module__w5v9IG__sponsorLogoRow",
});
